import { gasApi } from '@/api/gas'
import { DEVICE_TYPE_PRESETS } from '@/config/deviceTypes'

/** 从设备类型管理接口加载下拉选项，失败时使用本地兜底 */
export async function fetchDeviceTypeOptions() {
  try {
    const res = await gasApi.deviceType.options()
    const rows = res.data || []
    return rows.length ? rows : [...DEVICE_TYPE_PRESETS]
  } catch (e) {
    try {
      const legacy = await gasApi.device.terminalTypeOptions()
      const rows = legacy.data || []
      return rows.length ? rows : [...DEVICE_TYPE_PRESETS]
    } catch (err) {
      return [...DEVICE_TYPE_PRESETS]
    }
  }
}

export default {
  data() {
    return {
      deviceTypeOptions: [...DEVICE_TYPE_PRESETS]
    }
  },
  methods: {
    async loadDeviceTypeOptions() {
      this.deviceTypeOptions = await fetchDeviceTypeOptions()
    }
  }
}
